import {
  WithDateFilter,
  WithPaginationParams,
  HomeWaterTreatment,
  HWTTransactions,
} from 'types';
import { api } from './api';

export type HWTTransactionsParams = WithPaginationParams<
  WithDateFilter<{ id: string }>
>;

export const hwtService = api
  .enhanceEndpoints({
    addTagTypes: ['UserHwt', 'Hwt', 'HwtTransactions'],
  })
  .injectEndpoints({
    endpoints: ($) => ({
      getAllHWT: $.query<{ Items: HomeWaterTreatment[] }, string>({
        query: (userId: string) => ({
          method: 'get',
          url: `/hwt/${userId}/devices`,
        }),
        providesTags: (_res, _err, userId) => [{ type: 'UserHwt', id: userId }],
      }),
      createHWT: $.mutation({
        query: ({ userId, data }: { userId: string; data: unknown }) => ({
          url: `/hwt/${userId}/devices`,
          method: 'post',
          data,
        }),
        invalidatesTags: (_res, _err, { userId }) => [
          { type: 'UserHwt', id: userId },
        ],
      }),
      getHWT: $.query<HomeWaterTreatment, string>({
        query: (id: string) => ({ method: 'get', url: `/hwt/devices/${id}` }),
        providesTags: (_res, _err, id) => [{ type: 'Hwt', id }],
      }),
      getHWTTransactions: $.query<HWTTransactions, HWTTransactionsParams>({
        query: ({ id, ...params }) => ({
          method: 'get',
          url: `/hwt/devices/${id}/transactions`,
          params,
        }),
        providesTags: (_res, _err, { id }) => [{ type: 'HwtTransactions', id }],
      }),
      updateHWT: $.mutation({
        query: (data: HomeWaterTreatment) => ({
          url: `/hwt/devices/${data.Id}`,
          method: 'put',
          data,
        }),
        invalidatesTags: (_res, _err, { Id, OwnerId }) => [
          { type: 'Hwt', id: Id },
          { type: 'UserHwt', id: OwnerId },
        ],
      }),
      deleteHWT: $.mutation({
        query: (data: HomeWaterTreatment) => ({
          url: `/hwt/devices/${data.Id}`,
          method: 'delete',
        }),
        invalidatesTags: (_res, _err, { OwnerId }) => [
          { type: 'UserHwt', id: OwnerId },
        ],
      }),
      updateMaintenanceDate: $.mutation({
        query: (data: HomeWaterTreatment) => ({
          url: `/hwt/devices/${data.Id}/maintenance`,
          method: 'post',
          data: { Date: data.NextMaintenanceDt },
        }),
        invalidatesTags: (_res, _err, { Id, OwnerId }) => [
          { type: 'Hwt', id: Id },
          { type: 'UserHwt', id: OwnerId },
        ],
      }),
      setBalance: $.mutation({
        query: ({
          Id,
          Balance,
          Description,
        }: HomeWaterTreatment & { Description: string }) => ({
          url: `/hwt/devices/${Id}/balance`,
          method: 'post',
          data: { Balance, Description },
        }),
        invalidatesTags: (_res, _err, { Id, OwnerId }) => [
          { type: 'Hwt', id: Id },
          { type: 'UserHwt', id: OwnerId },
          { type: 'HwtTransactions', id: Id },
        ],
      }),
    }),
  });

export const { useSetBalanceMutation } = hwtService;
